//https://blog.logrocket.com/simplify-react-state-management-with-hookstate/
import { hookstate } from '@hookstate/core'

const globalErrorStore = hookstate([]);
export default globalErrorStore;